import { render } from "./DriverLanding.vue?vue&type=template&id=3c3585fd&scoped=true&ts=true"
import script from "./DriverLanding.vue?vue&type=script&lang=ts"
export * from "./DriverLanding.vue?vue&type=script&lang=ts"

import "./DriverLanding.vue?vue&type=style&index=0&id=3c3585fd&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3585fd"]])

export default __exports__